import { render, staticRenderFns } from "./CompareParameter.vue?vue&type=template&id=28b81bf6&scoped=true&"
import script from "./CompareParameter.vue?vue&type=script&lang=ts&"
export * from "./CompareParameter.vue?vue&type=script&lang=ts&"
import style0 from "./CompareParameter.vue?vue&type=style&index=0&id=28b81bf6&lang=less&scoped=true&"
import style1 from "./CompareParameter.vue?vue&type=style&index=1&id=28b81bf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b81bf6",
  null
  
)

export default component.exports